import { DiscountTypes } from "@/common/enums";

export default class WorldPaySiteSettingsModel {
    acceptorId: string = "";
    accountId: string = "";
    accountToken: string = "";
    terminalId: string = "";
}
